import type { Audit, SilverfinContext } from '@app/shared/types/sf-data'
import type { ChangesSinceLastVisit, PaginationMeta } from '../types'

import SFetch from '@app/utils/sfetch'

export const getAudits = ({
  contextType,
  contextId,
  page,
}: {
  contextType?: SilverfinContext.Account | SilverfinContext.ReconciliationText
  contextId?: number
  page?: number
} = {}): Promise<{
  audits: Audit[]
  pagination?: PaginationMeta
} | null> => {
  const params: Record<string, unknown> = {
    ...window.Silverfin.jsonParams,
    ledger_id: window.Silverfin.currentLedgerId(),
    context_type: contextType,
    context_id: contextId,
  }

  if (page) {
    params.page = page
  }

  const url = window.Silverfin.Routes.for_template_ledger_audits_path(params)

  return SFetch.json<{
    audits: Audit[]
    pagination?: PaginationMeta
  }>(url)
}

export const getChangesSinceLastVisit = ({
  contextType,
  contextId,
}: {
  contextType: SilverfinContext.Account | SilverfinContext.ReconciliationText
  contextId: number
}): Promise<{
  changesSinceLastVisit: ChangesSinceLastVisit
} | null> => {
  const params = {
    ...window.Silverfin.jsonParams,
    ledger_id: window.Silverfin.currentLedgerId(),
    context_type: contextType,
    context_id: contextId,
  }

  const url =
    window.Silverfin.Routes.changes_since_last_visit_ledger_audits_path(params)

  return SFetch.json<{
    changesSinceLastVisit: ChangesSinceLastVisit
  }>(url)
}
